__turbopack_context__.v({
  "badge": "h1Q7sa_badge",
  "badgeL": "h1Q7sa_badgeL",
  "text": "h1Q7sa_text",
});
